import type { ComponentProps, ReactNode, RefObject } from "react"
import { Button } from "@/ui/components/ui/button"

type Props = Omit<ComponentProps<typeof Button>, "size"> & {
  icon: ReactNode
  size?: "icon" | "icon-xs" | "icon-sm" | "icon-lg"
  ref?: RefObject<HTMLAnchorElement | null>
}

export default function IconButton({
  icon,
  size = "icon",
  variant = "ghost",
  ...buttonProps
}: Props) {
  return (
    <Button size={size} variant={variant} {...buttonProps}>
      {icon}
    </Button>
  )
}
